<template>
  <!-- <template
    v-if="!getDownload.loading && !getDownload.err &&
      getDownload.data && getDownload.data.meta.release_notes"
  >
    <button
      class="release-btn u-color-disabled"
      @click.prevent="openModal = true"
    >
      {{ t('versionNotes') }}
    </button>
    <VersionNotesModal
      v-model:open="openModal"
      :release-notes="getDownload.data.meta.release_notes"
    />
  </template> -->
  <button
    class="release-btn u-color-disabled"
    @click.prevent="openModal = true"
  >
    {{ t('versionNotes') }}
  </button>
  <VersionNotesModal
    v-model:open="openModal"
    :version-notes="versionNotes"
    :version-name="versionName"
  />
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from '@/utils/i18n'
// import { useDownloadContext } from '@/contexts/ProjectContext'
import VersionNotesModal from '@/components/VersionNotesModal.vue'

const props = withDefaults(defineProps<{
  versionNotes?: string,
  versionName?: string
}>(), { versionNotes: undefined, versionName: undefined })

// const getDownload = useDownloadContext()
const openModal = ref(false)

const versionNotes = ref(props.versionNotes)

const { t } = useI18n({
  messages: {
    en: {
      versionNotes: 'Version notes'
    },
    fr: {
      versionNotes: 'Notes de version'
    }
  }
})
</script>

<style scoped lang="scss">
@use "@/sass/settings";
@use "@/sass/helpers/mq";

.release-btn {
  color: #999999;
  text-decoration: underline;
  border: none;
  background: none;
  padding: 0;
  margin-top: 0;
  font-size: 1rem;

  @include mq.mq($until: small) {
    margin-top: 5px;
  }
}
</style>
